import React from 'react'
import PropTypes from 'prop-types'
import FilterItem from './FilterItem'
import { Menu, MenuList, MenuLabel } from '../../../bulma'

/**
* Sidebar filter component for Prices.
*/
class PriceFilter extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      // Stores the max value that was most recently changed.
      changedMax: null,
      // Stores the min value that was most recently changed.
      changedMin: null,
    }

    this.getLabel = this.getLabel.bind(this)
    this.onChangeHandler = this.onChangeHandler.bind(this)
    this.renderPriceOption = this.renderPriceOption.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    // If no longer loading, clear the changed values so we no longer show
    // a loading indicator on that filter item.
    if (this.props.isLoading && !nextProps.isLoading) {
      this.setState({
        changedMin: null,
        changedMax: null,
      })
    }
  }

  /**
  * Gets the display label based on a min and max price.
  *
  * @param min {number|string} min price.
  * @param max {number|string} max price.
  *
  * @returns {string}
  */
  getLabel(min, max) {
    if (min && max) {
      return `$${min} — $${max}`
    } else if (max && !min) {
      return `Under $${max}`
    } else if (min && !max) {
      return `Above $${min}`
    } else if (max === 0) {
      return 'Free'
    }

    return 'Any Price'
  }

  /**
  * onChange callback wrapper for when a price is clicked. Wraps the onChange
  * callback to store the recent changes in state and pass in a label for analytics.
  *
  * @param min {number|string} min price.
  * @param max {number|string} max price.
  */
  onChangeHandler(min, max) {
    this.setState({
      changedMin: min,
      changedMax: max,
    })

    this.props.onChange(min, max, this.getLabel(min, max))
  }

  /**
  * Renders a single `FilterItem` component based on given min/max.
  *
  * @param min {number|string} min price.
  * @param max {number|string} max price.
  *
  * @returns {object} `FilterItem` component.
  */
  renderPriceOption(min, max) {
    const {
      minValue, maxValue, isLoading, getFallbackUrl,
    } = this.props
    const isSelected = minValue == min && maxValue == max
    const priceIsLoading = isLoading && this.state.changedMin === min && this.state.changedMax === max
    const fallbackUrl = getFallbackUrl ? getFallbackUrl(min, max) : null

    return (
      <FilterItem
        onClick={() => {
this.onChangeHandler(min, max)
}}
        allowMultiple={false}
        isDisabled={isLoading}
        isLoading={priceIsLoading}
        isSelected={isSelected}
        fallbackUrl={fallbackUrl}
      >
        {this.getLabel(min, max)}
      </FilterItem>
    )
  }

  render() {
    const {
      title, minValue, maxValue, onChange, getFallbackUrl, isLoading, className, ...rest
    } = this.props
    const classes = [
      className || '',
      'is-shadowless',
    ]

    return (
      <Menu {...rest} className={classes.join(' ')}>
        {title ? <MenuLabel>{title}</MenuLabel> : false}
        <MenuList>
          {this.renderPriceOption(null, 0)}
          {this.renderPriceOption(null, 10)}
          {this.renderPriceOption(10, 25)}
          {this.renderPriceOption(25, 50)}
          {this.renderPriceOption(50, 100)}
          {this.renderPriceOption(100)}
          {this.renderPriceOption()}
        </MenuList>
      </Menu>
    )
  }
}

PriceFilter.defaultProps = {
  isLoading: false,
}

PriceFilter.propTypes = {
  isLoading: PropTypes.bool,
  maxValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  minValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string,
}

export default PriceFilter
